import fetch from '../../auth/FetchInterceptor';
import { API_URL } from '../../configs/AppConfig';

const BASE = `${API_URL}/api/app/hr/master-data`;

// Omitting `key` returns every list at once, grouped by key — used to warm the
// app-wide cache in RootContext on login.
export function requestMasterDataList(params = {}) {
  return fetch.get(BASE, { params });
}

export function requestCreateMasterData(body) {
  return fetch.post(BASE, body);
}

export function requestUpdateMasterData(id, body) {
  return fetch.put(`${BASE}/${id}`, body);
}

export function requestDeleteMasterData(id) {
  return fetch.delete(`${BASE}/${id}`);
}
